import { render, staticRenderFns } from "./ControlUnknown.vue?vue&type=template&id=5e0c9036"
import script from "./ControlUnknown.vue?vue&type=script&lang=js"
export * from "./ControlUnknown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports